import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-manager-ecommerce',
  templateUrl: './manager-ecommerce.component.html',
  styleUrls: ['./manager-ecommerce.component.scss']
})
export class ManagerEcommerceComponent implements OnInit {
  
  role: any = localStorage.getItem('role');
  managerId = localStorage.getItem('managerId');
  managerStores: any[] = [];
  loading: boolean = false;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    // Verify user is a manager
    if (this.role !== 'manager' || !this.managerId) {
      this.toastr.error('Access denied. Store managers only.');
      this.router.navigate(['/dashboard']);
      return;
    }

    this.loadManagerStores();
  }

  loadManagerStores(): void {
    this.loading = true;
    this.spinner.show();

    this.apiService.getRequest(`${ApiUrl.storeListById}${this.managerId}`)
      .subscribe(
        (res: any) => {
          this.loading = false;
          this.spinner.hide();
          
          if (res && res.response && res.response.data) {
            this.managerStores = res.response.data;
            
            // If manager has only one store, redirect directly to ecommerce panel
            if (this.managerStores.length === 1) {
              this.openEcommerceAdmin(this.managerStores[0]._id);
              return;
            }
          } else {
            this.toastr.error('No stores found for this manager');
            this.managerStores = [];
          }
        },
        (error: any) => {
          this.loading = false;
          this.spinner.hide();
          console.error('Error loading manager stores:', error);
          this.toastr.error('Failed to load stores');
        }
      );
  }

  openEcommerceAdmin(storeId: string): void {
    this.router.navigate(['/store', storeId, 'ecommerce']);
  }

  getStoreStatusText(store: any): string {
    return store.status === 1 ? 'Active' : 'Inactive';
  }

  getStoreStatusClass(store: any): string {
    return store.status === 1 ? 'text-success' : 'text-danger';
  }

  hasEcommerceEnabled(store: any): boolean {
    return store.ecommerceEnabled === true;
  }
}